import { type RefObject, useEffect, useRef } from 'react';

import { POIFilterType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiFilterType';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface PoiInteractionState {
    prevFilterTypeRef: RefObject<POIFilterType | undefined>;
    prevIndexRef: RefObject<number | undefined>;
    selectedPoiIndexRef: RefObject<number | undefined>;
}

export const usePoiSelectionInfo = (): PoiInteractionState => {
    const prevFilterTypeRef = useRef<POIFilterType | undefined>(undefined);
    const prevIndexRef = useRef<number | undefined>(undefined);
    const selectedPoiIndexRef = useRef<number | undefined>(usePlacementStore.getState().poiSelection.current.index);

    useEffect(() => {
        const unsubscribe = usePlacementStore.subscribe(
            (state) => state.poiSelection.current.index,
            (newIndex) => {
                selectedPoiIndexRef.current = newIndex;
            }
        );

        return () => unsubscribe();
    }, []);

    return {
        prevFilterTypeRef,
        prevIndexRef,
        selectedPoiIndexRef
    };
};